module.exports = __webpack_public_path__ + "static/media/clouds.0e2ed785.svg";